<template>
  <div class="am-log" >
    <table class="am-log-table">
      <thead>
        <tr>
          <template>
            <th>Field Name</th>
            <th>Before</th>
            <th>After</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(field, index) in singleViewRow.logViewItemsRow.changedFields">
          <td class="am-log-row">{{updateFieldName(index)}}</td>
          <td class="am-log-row" :title=field.before>{{field.before}}</td>
          <td class="am-log-row" :title=field.after>{{field.after}}</td>
        </tr>
        <tr v-if="singleViewRow.logViewItemsRow.changedFields.length === 0">
          <td>NO CHANGE</td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
    export default {
        name: 'viewLogs',
        props: {
            width: {
                type: String,
            },
            singleViewRow:{
                type: Array,
                default: () => []
            }
        },
        methods: {
            updateFieldName(fieldName) {
                if(fieldName !== ""){
                    fieldName = fieldName.split("_").join(" ")
                    fieldName = fieldName.toUpperCase()
                } else {
                    fieldName = "NO CHANGE"
                }
                return fieldName
            },
        }
    }
</script>

<style scoped>
  .am-log{
    padding: 5px 30px 10px 30px;
    width: 100%;
  }
  .am-log-table {
    width: 100%;
  }

  .am-log-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-log-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-log-table th {
    background-color: black;
    color: white;
  }

  .am-log-table td {
    padding: 2px;
    font-size: 11px;
    text-align: center;
  }

  .am-log-table th {
    padding: 2px;
    font-size: 11px;
    text-align: center;
  }

  .am-log-row {
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
  }

</style>
